import script from "./digiproperty.vue?vue&type=script&lang=ts&setup=true"
export * from "./digiproperty.vue?vue&type=script&lang=ts&setup=true"

import "./digiproperty.vue?vue&type=style&index=0&id=6ffdd8f1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffdd8f1"]])

export default __exports__